/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {DOCUMENT} from '@angular/common';
import {AfterViewInit, Directive, ElementRef, HostListener, Injector, OnDestroy} from '@angular/core';
import {FocusTrapTracker} from './focus-trap-tracker.service';
export class FocusTrapDirective implements AfterViewInit, OnDestroy {
private _previousActiveElement: HTMLElement;
private document: Document;
/**
 * @param {?} elementRef
 * @param {?} injector
 * @param {?} focusTrapsTracker
 */
constructor(public elementRef: ElementRef, injector: Injector,
private focusTrapsTracker: FocusTrapTracker) {
        this.document = injector.get(DOCUMENT);
        this.focusTrapsTracker.current = this;
    }
/**
 * @param {?} event
 * @return {?}
 */
onFocusIn(event: any) {
        const /** @type {?} */ nativeElement: HTMLElement = this.elementRef.nativeElement;

        if (this.focusTrapsTracker.current === this && !nativeElement.contains(event.target)) {
            nativeElement.focus();
        }
    }
/**
 * @return {?}
 */
ngAfterViewInit() {
        this._previousActiveElement = /** @type {?} */(( <HTMLElement>document.activeElement));
        const /** @type {?} */ nativeElement: HTMLElement = this.elementRef.nativeElement;
        nativeElement.setAttribute("tabindex", "0");
    }
/**
 * @return {?}
 */
public setPreviousFocus(): void {
        if (this._previousActiveElement && this._previousActiveElement.focus) {
            this._previousActiveElement.focus();
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.setPreviousFocus();
        this.focusTrapsTracker.activatePreviousTrapper();
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrFocusTrap]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Injector, },
{type: FocusTrapTracker, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onFocusIn': [{ type: HostListener, args: ["document:focusin", ["$event"], ] },],
};
}

function FocusTrapDirective_tsickle_Closure_declarations() {
/** @type {?} */
FocusTrapDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FocusTrapDirective.ctorParameters;
/** @type {?} */
FocusTrapDirective.propDecorators;
/** @type {?} */
FocusTrapDirective.prototype._previousActiveElement;
/** @type {?} */
FocusTrapDirective.prototype.document;
/** @type {?} */
FocusTrapDirective.prototype.elementRef;
/** @type {?} */
FocusTrapDirective.prototype.focusTrapsTracker;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
